import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeactivateDistrictMutationVariables = GraphQLTypes.Exact<{
  unitId: GraphQLTypes.Scalars['String']['input'];
}>;


export type DeactivateDistrictMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deactivateUnit'>
);


export const DeactivateDistrictDocument = /*#__PURE__*/ gql`
    mutation deactivateDistrict($unitId: String!) {
  deactivateUnit(unitId: $unitId)
}
    `;

/**
 * __useDeactivateDistrictMutation__
 *
 * To run a mutation, you first call `useDeactivateDistrictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDistrictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateDistrictMutation, { data, loading, error }] = useDeactivateDistrictMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useDeactivateDistrictMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateDistrictMutationResult, DeactivateDistrictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateDistrictMutationResult, DeactivateDistrictMutationVariables>(DeactivateDistrictDocument, options);
      }
export type DeactivateDistrictMutationHookResult = ReturnType<typeof useDeactivateDistrictMutation>;